<template>
  <layout-content-vertical-nav :nav-menu-items="filteredNavItems">
    <slot></slot>

    <!-- Slot: Navbar -->
    <template #navbar="{ isVerticalNavMenuActive, toggleVerticalNavMenuActive }">
      <div
        class="navbar-content-container"
        :class="{'expanded-search': shallShowFullSearch}"
      >
        <!-- Left Content: Search -->
        <div class="d-flex align-center">
          <v-icon
            v-if="$vuetify.breakpoint.mdAndDown"
            class="me-3"
            @click="toggleVerticalNavMenuActive"
          >
            {{ icons.mdiMenu }}
          </v-icon>
          <!-- <app-bar-search
            :shall-show-full-search.sync="shallShowFullSearch"
            :data="appBarSearchData"
            :filter="searchFilterFunc"
            :search-query.sync="appBarSearchQuery"
            @update:shallShowFullSearch="handleShallShowFullSearchUpdate(isVerticalNavMenuActive, toggleVerticalNavMenuActive)"
          ></app-bar-search> -->
        </div>
        <!-- Right Content: I18n, Light/Dark, Notification & User Dropdown -->
        <div class="d-flex align-center right-row">
          <AppBarI18n class="mr-4"></AppBarI18n>
          <AppBarThemeSwitcher></AppBarThemeSwitcher>
          <app-bar-user-menu></app-bar-user-menu>
        </div>
        <v-dialog
          v-model="showTOS"
          scrollable
          fullscreen
        >
          <v-card>
            <v-card-title class="text-uppercase">
              {{ $t('TermsOfService') }}
              <v-spacer />
              <v-btn
                icon
                small
                @click="showTOS = false"
              >
                <v-icon>{{ icons.mdiClose }}</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <component :is="tac"></component>
            </v-card-text>
            <v-card-actions>
              <v-btn
                block
                color="error"
                @click="showTOS = false"
              >
                {{ $t('Close') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

    <!-- Slot: Footer -->
    <template #footer>
      <div class="d-flex justify-space-between">
        <span>COPYRIGHT &copy; {{ new Date().getFullYear() }} <a
          href="#"
          class="text-decoration-none"
        >SmartCity</a><span class="d-none d-md-inline">, All rights Reserved.</span><br /><span class="text-capitalize"><a @click="showTOS=true">{{ $t('TermsOfService') }}</a></span></span>
      </div>
    </template>
  </layout-content-vertical-nav>
</template>

<script>
import LayoutContentVerticalNav from '@/@core/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'

// Search Data
import appBarSearchData from '@/assets/app-bar-search-data'
import AppBarI18n from '@/components/AppBarI18n.vue'

// App Bar Components
import AppBarUserMenu from '@/components/AppBarUserMenu.vue'

// import AppBarSearch from '@core/layouts/components/app-bar/AppBarSearch.vue'
import navMenuItems from '@/navigation/vertical'
import store from '@/store'
import TacEn from '@/views/Tac-en.vue'
import Tac from '@/views/Tac.vue'
import AppBarThemeSwitcher from '@core/layouts/components/app-bar/AppBarThemeSwitcher.vue'
import { getVuetify } from '@core/utils'
import { mdiHeartOutline, mdiMenu } from '@mdi/js'
import { computed, ref, watch } from '@vue/composition-api'

export default {
  components: {
    LayoutContentVerticalNav,

    // App Bar Components
    // AppBarSearch,
    AppBarUserMenu,
    AppBarThemeSwitcher,
    AppBarI18n,
  },
  computed: {
    tac() {
      return this.$i18n.locale === 'en' ? TacEn : Tac
    },
  },
  setup() {
    const $vuetify = getVuetify()

    const showTOS = ref(false)

    // Search
    const appBarSearchQuery = ref('')
    const shallShowFullSearch = ref(false)
    const maxItemsInGroup = 5
    const totalItemsInGroup = ref({
      pages: 0,
      files: 0,
      contacts: 0,
    })

    const currentUser = store.getters['auth/currentUser']

    const filteredNavItems = computed(
      () =>
        // eslint-disable-next-line implicit-arrow-linebreak
        navMenuItems.filter(nav => {
          if (nav.subheader && currentUser?.role === 1) {
            return false
          }

          if (nav.permission && !currentUser?.permission[nav.permission]) {
            return false
          }

          return true
        }),
      // eslint-disable-next-line function-paren-newline
    )

    watch(appBarSearchQuery, () => {
      totalItemsInGroup.value = {
        pages: 0,
        files: 0,
        contacts: 0,
      }
    })

    // NOTE: Update search function according to your usage
    const searchFilterFunc = (item, queryText, itemText) => {
      if (item.header || item.divider) return true

      const itemGroup = (() => {
        if (item.to !== undefined) return 'pages'
        if (item.size !== undefined) return 'files'
        if (item.email !== undefined) return 'contacts'

        return null
      })()

      const isMatched = itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1

      if (isMatched) {
        if (itemGroup === 'pages') totalItemsInGroup.value.pages += 1
        else if (itemGroup === 'files') totalItemsInGroup.value.files += 1
        else if (itemGroup === 'contacts') totalItemsInGroup.value.contacts += 1
      }

      return appBarSearchQuery.value && isMatched && totalItemsInGroup.value[itemGroup] <= maxItemsInGroup
    }

    // ? Handles case where in <lg vertical nav menu is open and search is triggered using hotkey then searchbox is hidden behind vertical nav menu overlaty
    const handleShallShowFullSearchUpdate = (isVerticalNavMenuActive, toggleVerticalNavMenuActive) => {
      if ($vuetify.breakpoint.mdAndDown && isVerticalNavMenuActive) {
        toggleVerticalNavMenuActive()
      }
    }

    return {
      showTOS,
      handleShallShowFullSearchUpdate,
      filteredNavItems,

      // Search
      appBarSearchQuery,
      shallShowFullSearch,
      appBarSearchData,
      searchFilterFunc,

      icons: {
        mdiMenu,
        mdiHeartOutline,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.navbar-content-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
}

// ? Handle bg of autocomplete for blured appBar
.v-app-bar.bg-blur {
  .expanded-search {
    ::v-deep .app-bar-autocomplete-box div[role='combobox'] {
      background-color: transparent;
    }

    > .d-flex > button.v-icon {
      display: none;
    }

    // ===

    & > .right-row {
      visibility: hidden;
      opacity: 0;
    }

    ::v-deep .app-bar-search-toggler {
      visibility: hidden;
    }
  }
}
</style>
